import React, { PureComponent } from 'react';
import { Switch, Route, Redirect, NavLink } from 'react-router-dom';
import Page from '../../components/Page';
import SendMessage from './sendmessage';
import History from './historytable';
import Telegram from './telegramsend';
import Contacts from './contacts';
import ContactsNew from './contacts_new';
import Unsub from './unsubs';
import ScheduleTable from './scheduletable';
import Templates from './templates';
import TemplateEditor from './templateeditor';
import { Icon, Toaster } from './ui';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { post } from '../../util/api';

class WGROUP extends PureComponent {
	state = { hasWaba: false };
	// WABA Şablonlar sekmesi yalnızca WhatsApp Business (360dialog) hattı olan hesaplarda
	componentDidMount() {
		let { product } = this.props;
		post('/broadcast/phoneList', { pid: product.id })
			.then((data) => this.setState({ hasWaba: !!(data.data && data.data.phones && data.data.phones.length) }))
			.catch(() => {});
	}
	render() {
		let { t, product } = this.props;
		let settings = (product && product.settings) || {};
		let isTelegramTemplate = settings.isTelegramTemplate;
		let merged = settings.merged_broadcast_list;
		let tabs = [
			{ to: '/wsendmessage', icon: 'send', label: t('sendMessage') },
			this.state.hasWaba && { to: '/wsendmessage/templates', icon: 'layout', label: t('WABA Şablonlar') },
			{ to: '/wsendmessage/schedules', icon: 'calendar', label: t('Planlamalar') },
			isTelegramTemplate && { to: '/wsendmessage/telegram', icon: 'send', label: t('Telegram') },
			{ to: '/wsendmessage/history', icon: 'clock', label: t('Geçmiş') },
			{ to: merged ? '/wsendmessage/contacts_new' : '/wsendmessage/contacts', icon: 'users', label: t('contacts') },
			merged && { to: '/wsendmessage/unsublist', icon: 'userX', label: t('unsublist') },
		].filter(Boolean);
		return (
			<Page title="WhatsApp Broadcast" icon="whatsapp">
				<div className="wsm">
						<div className="wsm-top">
							<nav className="wsm-tabs" aria-label={t('Bölümler')}>
								{tabs.map((tb) => (
									<NavLink key={tb.to} exact={tb.to === '/wsendmessage'} to={tb.to} className="wsm-tab" activeClassName="active">
										<Icon name={tb.icon} size={16} />
										{tb.label}
									</NavLink>
								))}
							</nav>
						</div>
						<div className="wsm-body">
							<Switch>
								{isTelegramTemplate && <Route path="/wsendmessage/telegram" exact component={Telegram}></Route>}
								<Route path="/wsendmessage/history" exact component={History}></Route>
								<Route path="/wsendmessage/schedules" exact component={ScheduleTable}></Route>
								<Route path="/wsendmessage/templates/new" exact component={TemplateEditor}></Route>
								<Route path="/wsendmessage/templates" exact component={Templates}></Route>
								<Route path="/wsendmessage/contacts" component={Contacts}></Route>
								<Route path="/wsendmessage" exact component={SendMessage}></Route>
								<Route path="/wsendmessage/contacts_new" component={ContactsNew}></Route>
								<Route path="/wsendmessage/unsublist" component={Unsub}></Route>
								<Redirect to="/wsendmessage" />
							</Switch>
						</div>
						<Toaster />
				</div>
			</Page>
		);
	}
}
const stateToProps = (state) => ({ access: state.access, location: state.router.location, product: state.product.live, user: state.access.user.loggedUserObj });
export default connect(stateToProps)(withTranslation()(WGROUP));
